import { render, staticRenderFns } from "./titleTop.vue?vue&type=template&id=2c4006fc&scoped=true"
import script from "./titleTop.vue?vue&type=script&lang=js"
export * from "./titleTop.vue?vue&type=script&lang=js"
import style0 from "./titleTop.vue?vue&type=style&index=0&id=2c4006fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4006fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4006fc')) {
      api.createRecord('2c4006fc', component.options)
    } else {
      api.reload('2c4006fc', component.options)
    }
    module.hot.accept("./titleTop.vue?vue&type=template&id=2c4006fc&scoped=true", function () {
      api.rerender('2c4006fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/titleTop.vue"
export default component.exports